<template>
	<up-popup :show="show" mask mode="bottom" mask-close-able closeable border-radius="16" safe-area-inset-bottom @close="close" @open="open">
		<view class="info">
			<view class="pic"><up-image :src="selectedSku.imgUrl" width="190rpx" height="190rpx"></up-image></view>
			<view class="desc">
				<view class="name">
					<text>{{ selectedSku.prodName }}</text>
				</view>
				<view class="price f_r_c_s" style="align-items: baseline !important;">
					<view>￥</view>
					<view>{{ selectedSku.price }}</view>
					<view v-if="membType == 1 && inSource == '004'">￥{{ selectedSku.udValue }}</view>
				</view>
				<view class="select" style="margin-bottom: 4rpx;">
					<text>库存:{{ selectedSku.redisVirtualNum }}</text>
				</view>
				<view class="select">
					<text>已选</text>
					<text>{{ selectedSku.label }}</text>
				</view>
			</view>
		</view>
		<!-- <view class="sku">
			<view class="title">规格</view>
			<view class="list">
				<view class="item" v-for="(item, index) in data.prodSingleProductBos" :key="index" :style="item.singleProdId == selectedSku.singleProdId?{ color: vuex_skinColor , border: '1px solid ' + vuex_skinColor}:''"  @click="selectSku(item, index)">
					{{ item.specDispStr }}
				</view>
			</view>
		</view> -->
		<view class="sku">
			<view class="title">规格</view>
			<scroll-view style="height: 200rpx;" scroll-y="true" show-scrollbar="false">
				<view class="list">
					<view class="item" v-for="(item, index) in data.prodSingleProductBos" :key="index" :style="item.singleProdId == selectedSku.singleProdId?{ color: vuex_skinColor , border: '1px solid ' + vuex_skinColor}:''"  @click="selectSku(item, index)">
						{{ item.specDispStr }}
					</view>
				</view>
			</scroll-view>
		</view>
		
		<view v-if="isIndexYxIn != 1" class="num">
			<view class="title">数量</view>
			<up-number-box v-model="num" @change="changeNum" min="0" integer></up-number-box>
		</view>
		<view v-if="!isYxOpen && !isThOpen" class="operate f_r_c_c" style="margin-bottom: 26rpx;">
			<up-button style="width: 45%;" :style="{ color: vuex_skinColor , border: '1px solid ' + vuex_skinColor}" type="dark" @click="addCartHandle" throttleTime='50'>加入购物车</up-button>
			<up-button style="width: 45%;" :color="vuex_skinColor" type="primary" @click="bugNowHandle" throttleTime='50'>立即购买</up-button>
		</view>
		<view v-if="(isYxOpen || isThOpen) && isIndexYxIn != 1" class="operate f_r_c_c" style="margin-bottom: 26rpx;">
			<up-button style="width: 90%;" :style="{ color: vuex_skinColor , border: '1px solid ' + vuex_skinColor}" type="dark" @click="addCartHandleYx" throttleTime='50'>加入购物车</up-button>
		</view>
	</up-popup>
</template>

<script setup>
	import {getCurrentInstance, reactive, ref} from "vue";
	import * as util from "@/utils/utils";
	// 获取Vue实例上下文
	const {ctx} = getCurrentInstance();
	// 定义可以触发的事件
	const emit = defineEmits(['fnClose','changeSku','changeNum','fnCountAmount','bugNowHandle'])
	// 定义 Props
	const props = defineProps({
	  show: {
	    type: Boolean,  
	    default: () => false 
	  },
	  data: {
	    type: Object,  
	    default: () => {} 
	  },
	  selectedSku: {
	    type: Object,  
	    default: () => {} 
	  },
	  membType: {
	    type: Number,  
	    default: () => 0 
	  },
	  isYxOpen: {
	    type: Boolean,  
	    default: () => false 
	  },
	  isThOpen: {
	    type: Boolean,  
	    default: () => false 
	  },
	  isIndexYxIn: {
	    type: Number,  
	    default: () => 0 
	  },
	  inSource: {
	    type: String,  
	    default: () => '004'
	  },
	});
	const num = ref(1);
	// 打开页面
	function open(){
		num.value = props.selectedSku.num
	}
	// 关闭页面
	function close(){
		emit('fnClose');
	}
	// 选择规格
	function selectSku(item,index){
		item.num = num.value;
		emit('changeSku',item);
	}
	// 变更数量
	function changeNum(e) {  
		emit('changeNum',e.value);
	}
	// 加入悦享专区购物车
	function addCartHandleYx(){
		if(!ctx.vuex_hasLogin){
			//不存在则跳转至登录页
			uni.navigateTo({
			  url: "/pages/login/login",
			})
			return
		}
		if(props.selectedSku.num == 0){
			ctx.$u.toast('请输入数量');
			return
		}
		if(props.isThOpen){
			// emit('addCartHandle');
			let cartItems = uni.getStorageSync('mall_thcart_'+uni.getStorageSync('lifeData').vuex_user.membId);
			// 判断当前产品在缓存中是否存在，存在，追加数量，不存在，加入
			if(cartItems && cartItems != undefined && cartItems != null && JSON.parse(cartItems).length > 0){
				let cartItemsNew = JSON.parse(cartItems);
				let flag = true;
				let returnFlag = true;
				for(let i=0;i<cartItemsNew.length;i++){
					if(props.selectedSku.singleProdId === cartItemsNew[i].singleProdId){
						cartItemsNew[i].num = util.fnAdd(cartItemsNew[i].num,props.selectedSku.num);
						if(cartItemsNew[i].num > props.selectedSku.redisVirtualNum){
							ctx.$u.toast(props.selectedSku.prodName+'('+props.selectedSku.specDispStr+')库存不足！');
							returnFlag = false;
							break
						}
						flag = false;
						break
					}
				}
				if(!returnFlag){
					return
				}
				if(flag){
					if(props.selectedSku.num > props.selectedSku.redisVirtualNum){
						ctx.$u.toast(props.selectedSku.prodName+'('+props.selectedSku.specDispStr+')库存不足！');
						return
					}
					let sku = props.selectedSku
					sku.checked = true
					cartItemsNew.push(sku)
				}
				cartItems = cartItemsNew;
			}else{
				if(props.selectedSku.num > props.selectedSku.redisVirtualNum){
					ctx.$u.toast(props.selectedSku.prodName+'('+props.selectedSku.specDispStr+')库存不足！');
					return
				}
				cartItems = [];
				let sku = props.selectedSku
				sku.checked = true
				cartItems.push(sku);
			}
			uni.setStorageSync('mall_thcart_'+uni.getStorageSync('lifeData').vuex_user.membId, JSON.stringify(cartItems));
			ctx.$u.toast("添加成功");
			emit('fnClose');
			emit('fnCountAmount');
		}else if(props.isYxOpen){
			// emit('addCartHandle');
			let cartItems = uni.getStorageSync('mall_yxcart_'+uni.getStorageSync('lifeData').vuex_user.membId);
			// 判断当前产品在缓存中是否存在，存在，追加数量，不存在，加入
			console.log("------------cartItems",cartItems)
			if(cartItems && cartItems != undefined && cartItems != null && JSON.parse(cartItems).length > 0){
				let cartItemsNew = JSON.parse(cartItems);
				let flag = true;
				let returnFlag = true;
				for(let i=0;i<cartItemsNew.length;i++){
					if(props.selectedSku.singleProdId === cartItemsNew[i].singleProdId){
						cartItemsNew[i].num = util.fnAdd(cartItemsNew[i].num,props.selectedSku.num);
						if(cartItemsNew[i].num > props.selectedSku.redisVirtualNum){
							ctx.$u.toast(props.selectedSku.prodName+'('+props.selectedSku.specDispStr+')库存不足！');
							returnFlag = false;
							break
						}
						flag = false;
						break
					}
				}
				if(!returnFlag){
					return
				}
				if(flag){
					if(props.selectedSku.num > props.selectedSku.redisVirtualNum){
						ctx.$u.toast(props.selectedSku.prodName+'('+props.selectedSku.specDispStr+')库存不足！');
						return
					}
					let sku = props.selectedSku
					sku.checked = true
					cartItemsNew.push(sku)
				}
				cartItems = cartItemsNew;
			}else{
				if(props.selectedSku.num > props.selectedSku.redisVirtualNum){
					ctx.$u.toast(props.selectedSku.prodName+'('+props.selectedSku.specDispStr+')库存不足！');
					return
				}
				cartItems = [];
				let sku = props.selectedSku
				sku.checked = true
				cartItems.push(sku);
			}
			uni.setStorageSync('mall_yxcart_'+uni.getStorageSync('lifeData').vuex_user.membId, JSON.stringify(cartItems));
			ctx.$u.toast("添加成功");
			emit('fnClose');
			emit('fnCountAmount');
		}
	}
	// 加入购物车
	function addCartHandle(){
		if(!ctx.vuex_hasLogin){
			//不存在则跳转至登录页
			uni.navigateTo({
			  url: "/pages/login/login",
			})
			return
		}
		if(props.selectedSku.num == 0){
			ctx.$u.toast('请输入数量');
			return
		}
		console.log("-----------------------props.selectedSku",JSON.stringify(props.selectedSku))
		// emit('addCartHandle');
		let cartItems = uni.getStorageSync('mall_cart_'+uni.getStorageSync('lifeData').vuex_user.membId);
		// 判断当前产品在缓存中是否存在，存在，追加数量，不存在，加入
		if(cartItems && cartItems != undefined && cartItems != null && JSON.parse(cartItems).length > 0){
			let cartItemsNew = JSON.parse(cartItems);
			let flag = true;
			let returnFlag = true;
			for(let i=0;i<cartItemsNew.length;i++){
				if(props.selectedSku.singleProdId === cartItemsNew[i].singleProdId){
					cartItemsNew[i].num = util.fnAdd(cartItemsNew[i].num,props.selectedSku.num);
					if(cartItemsNew[i].num > props.selectedSku.redisVirtualNum){
						ctx.$u.toast(props.selectedSku.prodName+'('+props.selectedSku.specDispStr+')库存不足！');
						returnFlag = false;
						break
					}
					flag = false;
					break
				}
			}
			if(!returnFlag){
				return
			}
			if(flag){
				if(props.selectedSku.num > props.selectedSku.redisVirtualNum){
					ctx.$u.toast(props.selectedSku.prodName+'('+props.selectedSku.specDispStr+')库存不足！');
					return
				}
				cartItemsNew.push(props.selectedSku)
			}
			cartItems = cartItemsNew;
		}else{
			if(props.selectedSku.num > props.selectedSku.redisVirtualNum){
				ctx.$u.toast(props.selectedSku.prodName+'('+props.selectedSku.specDispStr+')库存不足！');
				return
			}
			cartItems = [];
			cartItems.push(props.selectedSku);
		}
		uni.setStorageSync('mall_cart_'+uni.getStorageSync('lifeData').vuex_user.membId, JSON.stringify(cartItems));
		ctx.$u.toast("添加购物车成功");
		emit('fnClose');
	}
	// 立即购买
	function bugNowHandle(){
		if(!ctx.vuex_hasLogin){
			//不存在则跳转至登录页
			uni.navigateTo({
			  url: "/pages/login/login",
			})
			return
		}
		if(props.selectedSku.num == 0){
			ctx.$u.toast('请输入数量');
			return
		}
		if(props.selectedSku.num > props.selectedSku.redisVirtualNum){
			ctx.$u.toast(props.selectedSku.prodName+'('+props.selectedSku.specDispStr+')库存不足！');
			return
		}
		emit('bugNowHandle');
	}
</script>

<style lang="scss" scoped>
.info {
	padding: 60rpx 30rpx 0 30rpx;
	display: flex;
	align-items: flex-end;
	.pic {
		margin-right: 30rpx;
	}
	.desc {
		.name {
		  font-size: 28rpx;
		  color: #333;
		  padding: 10rpx 10rpx 10rpx 0;
		  overflow: hidden;
		  text-overflow: ellipsis;
		  white-space: nowrap;
		}
		.price {
			margin-bottom: 10rpx;
			view:nth-child(1) {
				font-size: 24rpx;
				color: #fd4558;
				vertical-align: bottom;
			}
			view:nth-child(2) {
				font-size: 36rpx;
				color: #fd4558;
				vertical-align: bottom;
			}
			view:nth-child(3) {
				font-size: 28rpx;
				color: #cccccc;
				text-decoration-line: line-through;
				margin-left: 20rpx;
			}
		}
		.select {
			text:nth-child(1) {
				font-size: 24rpx;
				color: #696969;
				margin-right: 20rpx;
			}
			text:nth-child(2) {
				font-size: 24rpx;
				color: #171717;
			}
		}
	}
}
.sku {
	padding: 30rpx 30rpx 0 30rpx;
	
	// height: 300px;
	
	.title {
		font-size: 28rpx;
		color: #171717;
		margin-bottom: 16rpx;
	}
	.list {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-wrap: wrap;
		.item {
			
			
			padding: 6rpx 10rpx 6rpx 10rpx;
			margin-bottom: 24rpx;
			margin-right: 20rpx;
			background-color: #f5f5f8;
			font-size: 24rpx;
			border-radius: 10rpx;
			color: #171717;
			border: 1rpx solid #f5f5f8;
			&.select {
				color: #5758f6;
				border: 1rpx solid #5758f6;
				background-color: rgba(#5758f6, 0.08);
			}
		}
	}
}
.num {
	padding: 30rpx;
	display: flex;
	justify-content: space-between;
	align-items: center;
	.title {
		font-size: 28rpx;
		color: #171717;
	}
}
.operate {
	display: flex;
	align-items: center;
	button {
		height: 80rpx;
		line-height: 80rpx;
		border-radius: 100rpx !important;
		&::after {
			border: initial;
		}
	}
}
</style>
